var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDotsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4,
    y: -4,
    width: 44,
    height: 44
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_3467_121484_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    "data-figma-bg-blur-radius": 4,
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#1A1A1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2061 24.1051C16.2059 24.4602 16.311 24.8073 16.5081 25.1025C16.7052 25.3978 16.9855 25.628 17.3134 25.764C17.6413 25.9 18.0023 25.9357 18.3505 25.8665C18.6987 25.7974 19.0186 25.6265 19.2697 25.3755C19.5208 25.1245 19.6918 24.8047 19.7612 24.4565C19.8305 24.1083 19.795 23.7474 19.6592 23.4194C19.5234 23.0914 19.2933 22.811 18.9981 22.6138C18.703 22.4165 18.3559 22.3112 18.0009 22.3112C17.5254 22.3124 17.0697 22.5018 16.7334 22.8379C16.3971 23.1741 16.2075 23.6296 16.2061 24.1051Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2061 11.5441C16.2059 11.8991 16.311 12.2462 16.5081 12.5415C16.7052 12.8368 16.9855 13.067 17.3134 13.203C17.6413 13.3389 18.0023 13.3746 18.3505 13.3055C18.6987 13.2363 19.0186 13.0654 19.2697 12.8145C19.5208 12.5635 19.6918 12.2437 19.7612 11.8955C19.8305 11.5473 19.795 11.1864 19.6592 10.8584C19.5234 10.5304 19.2933 10.25 18.9981 10.0527C18.703 9.85546 18.3559 9.75018 18.0009 9.75018C17.5254 9.75139 17.0697 9.94075 16.7334 10.2769C16.3971 10.613 16.2075 11.0686 16.2061 11.5441Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2061 17.8253C16.2061 18.1803 16.3113 18.5273 16.5085 18.8224C16.7058 19.1176 16.9861 19.3476 17.314 19.4835C17.642 19.6193 18.0029 19.6549 18.351 19.5856C18.6992 19.5164 19.019 19.3454 19.27 19.0944C19.521 18.8434 19.692 18.5236 19.7612 18.1754C19.8305 17.8273 19.7949 17.4664 19.6591 17.1384C19.5233 16.8105 19.2932 16.5302 18.998 16.3329C18.7029 16.1357 18.3559 16.0304 18.0009 16.0304C17.5253 16.0319 17.0696 16.2215 16.7334 16.5577C16.3971 16.894 16.2075 17.3497 16.2061 17.8253Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_3467_121484_clip_path",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDotsVertical);
export default __webpack_public_path__ + "static/media/IconDotsVertical.576811f1dbb2d132511fb743092bf8d5.svg";
export { ForwardRef as ReactComponent };